<template>
    <AppHeader
        hide-back
        :safe-area-top="false"
        style="--beyond-header-height: 64px"
    >
        <template #title>
            Notifications
        </template>
    </AppHeader>
    <Notifications />
</template>

<script setup>
    import { useRoute } from 'vue-router'

    import Notifications from '@/components/shared/Notifications.vue'
    import { statusBar } from '@/services'

    const notificationsStore = useNotificationsStore()

    const route = useRoute()

    const activated = ref(false)

    const loadNotifications = () => {
        notificationsStore.fetch()
    }

    // When route changes to dashboard e.g. returning after viewing a notice, refresh the notifications
    // This view is kept alive so only load when it's currently activated
    watch(() => route.name, (name) => {
        if (name !== 'dashboard' || !activated.value) {
            return
        }
        loadNotifications()
    })

    onMounted(() => {
        statusBar.setTheme()
    })

    onActivated(() => {
        activated.value = true
        statusBar.setTheme()

        notificationsStore.removeAllDeliveredNotifications()
            .catch((error) => {
                console.log('Unable to clear notifications', error)
            })

        // Make a request to update notifications
        loadNotifications()
    })

    onDeactivated(() => {
        activated.value = false
    })
</script>
